module.exports = __webpack_public_path__ + "static/media/decathlonLogo.fdafa61e.png";